import axios from 'axios'

const baseURL = process.env.VUE_APP_ADMIN_SERVER + '/api/notifications'
export default {
  namespaced: true,
  state: {
    count_unread: 0
  },
  mutations: {
    setCountUnread (state, count) {
      state.count_unread = count
    },
    decrementCount (state) {
      state.count_unread--
    }
  },
  getters: {},
  actions: {
    getNotifications ({ commit }) {
      const promise = axios.get(baseURL)

      promise.then(response => {
        commit('setCountUnread', response.data.count)
      })

      return promise
    },
    deleteNotification ({ commit }, id) {
      return axios.delete(baseURL + '/' + id)
    },
    deleteAllNotification ({ commit }) {
      return axios.delete(baseURL + '/')
    }
  }
}
